module.exports = __webpack_public_path__ + "img/Calendar.0badb4ef.svg";